"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Used as FC secondary color.
 * Palette generated based on the FC main turquoise color with http://mcg.mbitson.com/#!?straitfromhere=%23202020
 * https://material.io/color/#!/?view.left=0&view.right=0 used for finding the accent colors
 */
const Turquoise = {
    50: "#EAF9F8",
    100: "#CBF1EE",
    200: "#A8E8E2",
    300: "#85DFD6",
    400: "#6AD8CE",
    500: "#50D1C5",
    600: "#49CCBF",
    700: "#40C6B8",
    800: "#37C0B0",
    900: "#27B5A3",
    A100: "#CBF1EE",
    A200: "#A8E8E2",
    A400: "#6AD8CE",
    A700: "#40C6B8",
};
exports.default = Turquoise;
